import { Dto } from '@core/data/dto/dto';
import { DtoImport } from '@core/utils/dto';
import { DeliveryOrdersSummarySchema } from './delivery-orders-summary.schema';

export class DeliveryOrdersSummary {
    public totalCount: number;
    public totalSales: number;
    public totalTips: number;
    public totalAccepted: number;
    public totalAssigned: number;
    public totalCanceled: number;
    public totalDelivered: number;
    public totalDropoff: number;
    public totalNew: number;
    public totalPickup: number;
    public totalRejected: number;
    public totalReturned: number;
    public totalReturning: number;
    public totalScheduled: number;
    public avgDistance: number;
    public avgDeliveryFee: number;
    public avgDeliveryFeeGap: number;

    @DtoImport(DeliveryOrdersSummarySchema)
    static import(dto: Dto): any {}
}
